export default class MuseumRoomState {
    constructor( props ) {
        this.galleries = props.galleries ?? [];
        this.currentGallery = null;
    }

    get isOpen() {
        return this.currentGallery !== null;
    }
}
